import { axios } from '@/plugins/axios';
import _ from 'lodash';
import { SearchByPsRequest } from './types';

export function searchByPS(
	request: SearchByPsRequest) {
	return axios.post('/vaccination-covid-api/foldersPs', request);
}

